module.exports = __webpack_public_path__ + "static/img/sharetips.c604f83.1721208215485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sharetips.png
// module id = kg+M
// module chunks = 65